var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffOnboardingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "staff-onboarding-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ZH.Screen.Web.Services-Coding",
    transform: "translate(-680, -3274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "staff-onboarding-icon",
    transform: "translate(690, 3284)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    fill: "#348389",
    cx: 60,
    cy: 60,
    r: 65
  }), /*#__PURE__*/React.createElement("g", {
    id: "nurse-svgrepo-com",
    transform: "translate(36, 29)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1091667,34.8663648 C17.5066667,34.2831 22.2319444,39.5470579 24.3531944,41.9100916 L24.3534722,41.9103666 C24.61,42.1960866 24.8283333,42.4394573 25,42.6248041 C25.2475,42.3742835 25.58875,42.0055149 25.9986111,41.5624977 L25.9986111,41.5624977 C28.2805556,39.0964783 32.6902778,34.3310867 34.8908333,34.8663648 C42.3965278,36.6923329 50,40.4156302 50,46.0167322 L50,55 L0,55 L0,46.0167322 C0,40.4156302 7.60347222,36.6923329 15.1091667,34.8663648 Z M38.8888889,43.99923 L41.6666667,43.99923 L41.6666667,46.7491819 L38.8888889,46.7491819 L38.8888889,49.4991338 L36.1111111,49.4991338 L36.1111111,46.7491819 L33.3333333,46.7491819 L33.3333333,43.99923 L36.1111111,43.99923 L36.1111111,41.2492781 L38.8888889,41.2492781 L38.8888889,43.99923 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7343056,1.91048782 C17.3231944,1.10328069 21.4797222,0 25,0 C28.5202778,0 32.6768056,1.10328069 35.2655556,1.91048782 C37.5584722,2.62542031 38.6023611,5.09896077 37.7472222,7.21536498 L34.6229167,16.3228893 C34.3423611,17.0171147 33.5529167,17.3622337 32.8456944,17.0996133 C27.6045833,15.1538848 22.3954167,15.1538848 17.1543056,17.0996133 C16.4470833,17.3622337 15.6576389,17.0171147 15.3770833,16.3228893 L12.2527778,7.21536498 C11.3976389,5.09896077 12.4415278,2.62542031 14.7343056,1.91048782 Z M26.3888889,6.87487969 L29.1666667,6.87487969 L29.1666667,9.62483157 L26.3888889,9.62483157 L26.3888889,12.3747834 L23.6111111,12.3747834 L23.6111111,9.62483157 L20.8333333,9.62483157 L20.8333333,6.87487969 L23.6111111,6.87487969 L23.6111111,4.12492781 L26.3888889,4.12492781 L26.3888889,6.87487969 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5695833,14.7805788 C16.5488889,16.5461854 15.2777778,19.1250903 15.2777778,21.999615 C15.2777778,27.315272 19.6305556,31.6244466 25,31.6244466 C30.3694444,31.6244466 34.7222222,27.315272 34.7222222,21.999615 C34.7222222,19.1250903 33.4511111,16.5461854 31.4304167,14.7805788 L33.2686111,12.7188024 C35.8613889,14.9843503 37.5,18.3034047 37.5,21.999615 C37.5,28.8339329 31.9036111,34.3743984 25,34.3743984 C18.0963889,34.3743984 12.5,28.8339329 12.5,21.999615 C12.5,18.3034047 14.1386111,14.9843503 16.7313889,12.7188024 L18.5695833,14.7805788 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffOnboardingIcon);
export default __webpack_public_path__ + "static/media/staff-onboarding-icon.7ccc92e5a600ae7e6f11042190efc988.svg";
export { ForwardRef as ReactComponent };